import { render, staticRenderFns } from "./ReservationIntro.vue?vue&type=template&id=7efd7fbf&scoped=true"
import script from "./ReservationIntro.vue?vue&type=script&lang=js"
export * from "./ReservationIntro.vue?vue&type=script&lang=js"
import style0 from "./ReservationIntro.vue?vue&type=style&index=0&id=7efd7fbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efd7fbf",
  null
  
)

export default component.exports